import React from "react";

const Card = React.forwardRef(function Card(
  { className = "", children, ...props },
  ref,
) {
  const classes = [
    "rounded-lg bg-white shadow dark:bg-gray-800",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div ref={ref} className={classes} {...props}>
      {children}
    </div>
  );
});

export default Card;
